import { useEffect, useState } from 'react'
import { formatAbsTs, formatTs } from '../../lib/format'
import { Tooltip, TooltipContent, TooltipTrigger } from '../ui/tooltip'

/** 相对时间 + 悬停绝对时间 */
export function TimeAgo({ ts, className, warnAfterMs }: { ts?: number | null; className?: string; warnAfterMs?: number }) {
  const [now, setNow] = useState(() => Date.now())
  useEffect(() => {
    const timer = setInterval(() => setNow(Date.now()), 30_000)
    return () => clearInterval(timer)
  }, [])
  if (!ts) return <span className={className}>—</span>
  const stale = warnAfterMs != null && now - ts > warnAfterMs
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span className={`cursor-default tabular-nums ${stale ? 'text-warning' : ''} ${className ?? ''}`}>
          {formatTs(ts)}
        </span>
      </TooltipTrigger>
      <TooltipContent>{formatAbsTs(ts)}</TooltipContent>
    </Tooltip>
  )
}
